import { ToolkitProperty, isDefined } from '@aloft/toolkit-shared';

import { ToolkitPropertyTableUI } from './ToolkitPropertyTableUI.tsx';
import { DEFAULT_COLUMNS } from './constants.ts';
import { makeCustomTPColumns } from './makeCustomTPColumns.tsx';
import { CustomTPColumn, TPColumnConfig, TPTableClickRow, TPTableSelectRow } from './types.ts';
import { useTPTableCore } from './useTPTableCore.ts';

type Props<Data, Value> = {
  data: Data[];
  columns?: CustomTPColumn<Data>[];
  pinnedColumnIds?: string[]; // TODO: Better type
  tpColumnConfig: TPColumnConfig<Data, Value>;
  subjectProperty?: ToolkitProperty;
  selectedRowIndices: number[];
  enableMultiSelect?: boolean;
  activeRowIndex: number | null;
  emptyTableMessage?: string;
  memoizeRows?: boolean;
  onRowClick?: TPTableClickRow<Data>;
  onRowSelect?: TPTableSelectRow<Data>;
};

export const CustomToolkitPropertyTable = <Data, Value>({
  data,
  columns = DEFAULT_COLUMNS,
  pinnedColumnIds,
  tpColumnConfig,
  subjectProperty,
  selectedRowIndices,
  activeRowIndex,
  emptyTableMessage,
  enableMultiSelect = false,
  memoizeRows,
  onRowClick,
  onRowSelect,
}: Props<Data, Value>) => {
  const table = useTPTableCore({
    data,
    columns: (sortingState) =>
      makeCustomTPColumns<Data, Value>(
        columns,
        tpColumnConfig,
        subjectProperty,
        sortingState,
        enableMultiSelect,
        onRowSelect,
      ),
    pinnedColumnIds,
    enableRowSelection: isDefined(onRowSelect),
    selectedRowIndices,
  });

  return (
    <ToolkitPropertyTableUI
      table={table}
      shouldPinFirstRow={!!subjectProperty}
      activeRowIndex={activeRowIndex}
      emptyTableMessage={emptyTableMessage}
      memoizeRows={memoizeRows}
      onRowClick={onRowClick}
    />
  );
};
